import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

const activeCss = css`
  color: ${themeGet('colors.font.accent')};
`

export const Container = styled.div`
  font-size: 12px;
  bottom: ${props => `${props.bottom}px`};
  font-weight: 300;
  color: ${themeGet('colors.error')};
  transition: all ${themeGet('transitionTime')} ease;
  position: absolute;
  top: 100%;

  ${props => props.active && activeCss};
`
